"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var noComparisonFinanceRatesBlockStyles = styles_1.makeStyles(function (_a) {
    var _b, _c;
    var palette = _a.palette, typography = _a.typography, breakpoints = _a.breakpoints;
    return ({
        referentialFinancial: (_b = {
                padding: '15px 0 0 12px',
                marginBottom: 0,
                fontWeight: typography.fontWeightBold
            },
            _b[breakpoints.down('sm')] = {
                fontSize: typography.fontMD,
                padding: '0 0 0 12px',
            },
            _b),
        repaymentLabel: {
            marginLeft: 12,
        },
        financeQuotePrice: {
            color: palette.text.primary,
            fontSize: typography.fontXL,
        },
        labelAfter: (_c = {},
            _c[breakpoints.down('sm')] = {
                padding: '0 0 0 12px',
                display: 'block',
            },
            _c),
    });
}, { name: 'Summary_NoComparisonFinanceRatesBlock' });
exports.default = noComparisonFinanceRatesBlockStyles;
